import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-11-06
	search(params) {
		return axios.get('/weddingDressHall/supplier', params)
	},
	// 2021-11-06
	findByPhone(params) {
		return axios.get('/weddingDressHall/supplier/find-by-phone', params)
	},
	//  2021-11-06
	create(params) {
		return axios.post('/weddingDressHall/supplier', params)
	},
	//  2021-11-06
	update(id, params) {
		return axios.put('/weddingDressHall/supplier/' + id, params)
	},
	// 2021-11-06
	delete(id) {
		return axios.delete('/weddingDressHall/supplier/' + id)
	},
	// 2021-11-06
	exportExcel(params) {
		return axios.get('/weddingDressHall/supplier/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-11-06
	findByTenantId() {
		return axios.get('/weddingDressHall/supplier/find-by-tenant-id')
	},
	// 2021-11-06
	findById(id) {
		return axios.get('/weddingDressHall/supplier/' + id)
	}
}

